import { TFunction } from 'i18next'
import { StepOptions } from 'particles/SideNavigator'
import { CampaignTaskElements } from 'services/api/campaignTemplates'

export const getOptions = (t: TFunction): StepOptions[] => {
    return [
        {
            id: 'campaign_info',
            title: t('campaign.template.step2.campaignInfo.title'),
            subtext: t('campaign.template.step2.campaignInfo.subText'),
            isCommented: false,
            isCompleted: false,
            isError: false,
            isDisabled: false,
        },
        {
            id: 'campaign_schedule',
            title: t('campaign.template.step2.campaignSchedule.title'),
            subtext: t('campaign.template.step2.campaignSchedule.subText'),
            isCommented: false,
            isCompleted: false,
            isError: false,
            isDisabled: false,
        },
    ]
}

export type ElementKeys =
    | 'purchase'
    | 'ig_reels'
    | 'tiktok_repost'
    | 'ig_story_repost'
    | 'tiktok'
    | 'ig_post'
    | 'ig_story_non_ugc_sticker_link'
    | 'review_text_image_approval'
    | 'download_app'
    | 'download_app_sign_up_without_id'
    | 'review_text_image_approval_purchase'
    | 'ig_story_ugc'
    | 'review_text_approval'
    | 'review_text'
    | 'review_text_purchase'
    | 'follow'
    | 'video_creation'
    | 'photo_creation'

export const getElementsOptions = (t: TFunction): Record<ElementKeys, StepOptions> => {
    return {
        purchase: {
            id: 'purchase',
            title: t('campaign.template.step2.purchaseTask.title'),
            subtext: t('campaign.template.step2.purchaseTask.subText'),
            isCommented: false,
            isCompleted: false,
            isError: false,
            isDisabled: false,
        },
        ig_reels: {
            id: 'ig_reels',
            title: t('campaign.template.step2.instagramReeosTask.subText'),
            subtext: t('campaign.template.step2.instagramReelsTask.subText'),
            isCommented: false,
            isCompleted: false,
            isError: false,
            isDisabled: false,
        },
        tiktok_repost: {
            id: 'tiktok_repost',
            title: t('campaign.template.step2.tiktokRepostTask.title'),
            subtext: t('campaign.template.step2.tiktokRepostTask.subText'),
            isCommented: false,
            isCompleted: false,
            isError: false,
            isDisabled: false,
        },
        ig_story_repost: {
            id: 'ig_story_repost',
            title: t('campaign.template.step2.instagramStoryRepostTask.title'),
            subtext: t('campaign.template.step2.instagramStoryRepost.subText'),
            isCommented: false,
            isCompleted: false,
            isError: false,
            isDisabled: false,
        },
        tiktok: {
            id: 'tiktok',
            title: t('campaign.template.step2.tiktokTask.title'),
            subtext: t('campaign.template.step2.tiktokTask.subText'),
            isCommented: false,
            isCompleted: false,
            isError: false,
            isDisabled: false,
        },
        ig_post: {
            id: 'ig_post',
            title: t('campaign.template.step2.instagramPostTask.title'),
            subtext: t('campaign.template.step2.instagramPostTask.subText'),
            isCommented: false,
            isCompleted: false,
            isError: false,
            isDisabled: false,
        },
        download_app: {
            id: 'download_app',
            title: t('campaign.template.step2.downloadAppTask.title'),
            subtext: t('campaign.template.step2.downloadAppTask.subText'),
            isCommented: false,
            isCompleted: false,
            isError: false,
            isDisabled: false,
        },
        download_app_sign_up_without_id: {
            id: 'download_app',
            title: t('campaign.template.step2.downloadRegisterAppTask.title'),
            subtext: t('campaign.template.step2.downloadRegisterAppTask.subText'),
            isCommented: false,
            isCompleted: false,
            isError: false,
            isDisabled: false,
        },
        ig_story_non_ugc_sticker_link: {
            id: 'ig_story_non_ugc_sticker_link',
            title: t('campaign.template.step2.instagramStoryNonUGC.title'),
            subtext: t('campaign.template.step2.instagramStoryNonUGC.subText'),
            isCommented: false,
            isCompleted: false,
            isError: false,
            isDisabled: false,
        },
        review_text_image_approval: {
            id: 'review_text_image_approval',
            title: t('campaign.template.step2.reviewTextImageWithApprovalTask.title'),
            subtext: t('campaign.template.step2.reviewTextImageWithApprovalTask.subText'),
            isCommented: false,
            isCompleted: false,
            isError: false,
            isDisabled: false,
        },
        review_text_image_approval_purchase: {
            id: 'review_text_image_approval_purchase',
            title: t('campaign.template.step2.reviewTextImageWithApprovalTask.title'),
            subtext: t('campaign.template.step2.reviewTextImageWithApprovalTask.subText'),
            isCommented: false,
            isCompleted: false,
            isError: false,
            isDisabled: false,
        },
        ig_story_ugc: {
            id: 'ig_story_ugc',
            title: t('campaign.template.step2.instagramStoryTask.title'),
            subtext: t('campaign.template.step2.instagramStoryTask.subText'),
            isCommented: false,
            isCompleted: false,
            isError: false,
            isDisabled: false,
        },
        review_text_approval: {
            id: 'review_text_with_approval',
            title: t('campaign.template.step2.reviewTextWithApprovalTask.title'),
            subtext: t('campaign.template.step2.reviewTextImageWithApprovalTask.subText'),
            isCommented: false,
            isCompleted: false,
            isError: false,
            isDisabled: false,
        },
        review_text: {
            id: 'review_text',
            title: t('campaign.template.step2.reviewTextTask.title'),
            subtext: t('campaign.template.step2.reviewTextTask.subText'),
            isCommented: false,
            isCompleted: false,
            isError: false,
            isDisabled: false,
        },
        review_text_purchase: {
            id: 'review_text_purchase',
            title: t('campaign.template.step2.reviewTextTask.title'),
            subtext: t('campaign.template.step2.reviewTextTask.subText'),
            isCommented: false,
            isCompleted: false,
            isError: false,
            isDisabled: false,
        },
        follow: {
            id: 'follow',
            title: t('campaign.template.step2.followTask.title'),
            subtext: t('campaign.template.step2.followTask.subText'),
            isCommented: false,
            isCompleted: false,
            isError: false,
            isDisabled: false,
        },
        video_creation: {
            id: 'video_creation',
            title: t('campaign.template.step2.videoCreationTask.title'),
            subtext: t('campaign.template.step2.videoCreationTask.subtext'),
            isCommented: false,
            isCompleted: false,
            isError: false,
            isDisabled: false,
        },
        photo_creation: {
            id: 'photo_creation',
            title: t('campaign.template.step2.photoCreationTask.title'),
            subtext: t('campaign.template.step2.photoCreationTask.subtext'),
            isCommented: false,
            isCompleted: false,
            isError: false,
            isDisabled: false,
        },
    }
}

export const fieldKeyByTasks: Record<ElementKeys, (keyof CampaignTaskElements)[]> = {
    purchase: ['products', 'min_purchase_quantity', 'example_medias', 'purchase_locations', 'shipping_fee', 'element'],
    ig_post: [
        'unique_selling_point',
        'example_medias',
        'example_media_description',
        'brand_handles',
        'caption_hashtags',
        'element',
    ],
    ig_reels: [
        'unique_selling_point',
        'example_medias',
        'example_media_description',
        'brand_handles',
        'caption_hashtags',
        'element',
    ],
    ig_story_repost: ['example_medias', 'brand_handles', 'caption_hashtags', 'element', 'brand_name'],
    tiktok_repost: ['brand_handles', 'caption_hashtags', 'element'],
    tiktok: [
        'unique_selling_point',
        'example_medias',
        'example_media_description',
        'brand_handles',
        'caption_hashtags',
        'element',
    ],
    download_app: ['app_name', 'download_links', 'element'],
    download_app_sign_up_without_id: ['app_name', 'download_links', 'element'],
    ig_story_non_ugc_sticker_link: [
        'sample_links',
        'unique_selling_point',
        'example_medias',
        'sticker_link',
        'customized_sticker_text',
        'brand_handles',
        'caption_hashtags',
        'element',
    ],
    review_text_image_approval: ['unique_selling_point', 'review_platform', 'review_link', 'element'],
    review_text_image_approval_purchase: ['unique_selling_point', 'review_platform', 'review_link', 'element'],
    ig_story_ugc: ['unique_selling_point', 'example_medias', 'brand_handles', 'caption_hashtags', 'element'],
    review_text_approval: ['unique_selling_point', 'review_platform', 'review_link', 'element'],
    review_text: ['unique_selling_point', 'review_platform', 'review_link', 'element'],
    review_text_purchase: ['unique_selling_point', 'review_platform', 'review_link', 'element'],
    follow: ['follow_platform', 'follow_platform_link', 'element'],
    video_creation: ['number_of_videos', 'unique_selling_point', 'mandatory_guidelines', 'example_medias', 'element'],
    photo_creation: ['unique_selling_point', 'mandatory_guidelines', 'example_medias', 'element'],
}
